import { Injectable } from '@angular/core';
import { IFileStorageService } from './contracts/file-storage.service';
import { ApiService } from './api.base.service';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { TempFileDescriptorModel } from '../../models/api-models/temp-file-descriptor-model';
import { FileDescriptorModel } from '../../models/api-models/file-descriptor-model';
import { FileAndImageModel } from '../../models/api-models/file-image-model';


@Injectable({ providedIn: 'root' })
export class FileStorageService implements IFileStorageService {

    constructor(
        private apiService: ApiService,
        private httpClient: HttpClient) {
    }

    uploadLocal(fileBase64: string): Promise<string> {
        throw new Error("Method not implemented.");
    }

    async getBase64(fileDescriptorId: string): Promise<FileAndImageModel> {
        return await this.apiService.get<FileAndImageModel>(`api/filestorage/getbase64/${fileDescriptorId}`);
    }

    updateFile(fileDescriptorId: string, fileBase64: string): Promise<void> {
        throw new Error("Method not implemented.");
    }

    public async upload(files: FileList, batchId?: string, password?: string, isEncrypted?: string): Promise<TempFileDescriptorModel[]> {
        let formData = new FormData();
        Array.from(files).forEach(file => {
            formData.append('Files', file, file.name);
        });

        if (batchId) {
            formData.append('BatchId', batchId);
        }

        if (password && password !== '') {
            formData.append('Password', password);
        }

        if (isEncrypted && isEncrypted != '') {
            formData.append('IsEncrypted', isEncrypted);
        } else {
            formData.append('IsEncrypted', 'false');
        }

        let response = [];

        if (password && password != '') {
            response = await this.apiService.post('api/filestorage/upload', formData);
        } else {
            response = await this.apiService.post('api/filestorage/upload', formData);
        }

        let tempFileDescriptors: TempFileDescriptorModel[] = [];
        Object.assign(tempFileDescriptors, response);
        return tempFileDescriptors;
    }

    public async commit(batchId: string): Promise<TempFileDescriptorModel[]> {
        let response = await this.apiService.post('api/filestorage/commit/' + batchId);
        let tempFileDescriptors: TempFileDescriptorModel[] = [];
        Object.assign(tempFileDescriptors, response);
        return tempFileDescriptors;
    }

    async remove(fileDescriptorId: string): Promise<void> {
        await this.apiService.delete('api/filestorage/' + fileDescriptorId);
    }

    async removeTempFile(fileDescriptorId: string): Promise<void> {
        await this.apiService.delete('api/filestorage/tempfile/' + fileDescriptorId);
    }
}